export const themeStyleDark = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#880808",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#880808",
  primaryButtonTextColor: "white",
  secondaryButtonColor: "#000080",
};

export const themeStyle = {
  backgroundColor: "#F4F5FA",
  primaryColor: "#880808",
  primaryCardColor: "white",
  textColor: "black",
  primaryButtonColor: "#880808",
  primaryButtonTextColor: "black",
  secondaryButtonColor: "#000080",
};
